/* ============================================================================
   CUSTOM: THANKS COUPON — クーポンコードのコピー（issue #614）
   templates/page.thanks-coupon.liquid だけで使う。

   [data-thx-copy="AUT500"] を押すと、その文字列をクリップボードに入れて、
   同じクーポン内の [data-thx-feedback] に「コピーしました」を出す。
     1. Clipboard API を使う（https と localhost で動く）
     2. 使えない環境では隠しテキストエリア＋execCommand に落とす
     3. 失敗したら**コードそのものを文に出す**（黙って何も起きないのを避ける）
        ★ コードは画像（AUT500.jpg / AUT800.jpg）の中にしか無く、選んでコピーできる
          文字が画面に無い。だから失敗時の文で「長押しして」と言ってはいけない
          ——コードを読める形で見せる必要がある。
   素の JS（IIFE）。ライブラリ非依存。
   ============================================================================ */
(function () {
  var RESET_MS = 2400;

  function findFeedback(button) {
    var scope = button.closest('[data-thx-coupon]');
    return scope ? scope.querySelector('[data-thx-feedback]') : null;
  }

  function say(button, message) {
    var feedback = findFeedback(button);
    if (!feedback) return;

    feedback.textContent = message;

    // 一定時間で消す。連打しても最後の1回だけが残るようにタイマーを持ち直す
    if (feedback.dataset.thxTimer) {
      window.clearTimeout(Number(feedback.dataset.thxTimer));
    }
    feedback.dataset.thxTimer = String(
      window.setTimeout(function () {
        feedback.textContent = '';
        delete feedback.dataset.thxTimer;
      }, RESET_MS)
    );
  }

  // Clipboard API が無い環境（古い iOS / http）向けの控え
  function legacyCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    document.body.appendChild(area);
    area.select();

    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(area);
    return ok;
  }

  // コードは画像の中にしか無いので、失敗したら文の中にコードを出す
  function failMessage(code) {
    return 'コピーできませんでした。コード「' + code + '」を手で入力してください';
  }

  function copy(button) {
    var code = button.getAttribute('data-thx-copy');
    if (!code) return;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(
        function () {
          say(button, 'コピーしました');
        },
        function () {
          say(button, legacyCopy(code) ? 'コピーしました' : failMessage(code));
        }
      );
      return;
    }

    say(button, legacyCopy(code) ? 'コピーしました' : failMessage(code));
  }

  function init(root) {
    if (!root || root.dataset.thxInit === 'true') return;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-thx-copy]'));
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        copy(button);
      });
    });

    root.dataset.thxInit = 'true';
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-thx-root]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
